import InputWithProgress from './InputWithProgress';

export default InputWithProgress;
